import { formatCdn } from "./format-cdn";

export const getResponsiveSrc = (
    url?: string | null,
    width = 400,
    format: "webp" | "avif" = "webp",
    quality = 70
): string => {
    if (!url) return "";
    const clean = formatCdn(url);
    return `${clean}?w=${width}&fm=${format}&q=${quality}`;
}
